import { Component, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNConsultation, CNConsultationType } from 'src/app/models/cnconsultation';
import { UserConfigService } from 'src/app/services/user-config.service';
import { UserOpenItemsService } from 'src/app/services/user-open-items.service';

@ManageType('ContactWidgetComponent')
@Component({
  selector: 'app-contact-widget',
  templateUrl: './contact-widget.component.html',
  styleUrls: ['./contact-widget.component.scss']
})
export class ContactWidgetComponent implements OnInit {

  constructor(private userOpenItemsSrv: UserOpenItemsService, private userConfig: UserConfigService) { }

  ngOnInit(): void {
  }

  newContact(): void {
    const newCons = new CNConsultation();
    // tslint:disable-next-line:max-line-length
    newCons.type = (this.userConfig.profileValue('CNConsultation', 'default') === false) ? CNConsultationType.Simple : this.userConfig.profileValue('CNConsultation', 'default') as CNConsultationType;
    newCons.setProperty('healthagentid', this.userConfig.userid);
    newCons.date = new Date();
    this.userOpenItemsSrv.addItem(newCons , true);
  }

}
